<div class="blocked-container width-660" tracking formname="Smart invest line simulation"
    stepname="Block  user  unknown  partner" submittrigger="button.ab-unknown-partner-block" stepclusterOptional="stop">
    <div class="blocked-intro-text" [innerHTML]="screenLabels.IntroText | translate | punctuationWrap"></div>
    <h2 class="blocked-title" [innerHTML]="screenLabels.title | translate:{PartnerName: partnerName} | punctuationWrap"></h2>
    <div class="blocked-image">
        <div id="jsonImageIcon" class="lottie blocked-large-image"></div>
    </div>
    <div class="blocked-content" [innerHTML]="screenLabels.desc | translate:{PartnerName: partnerName} | punctuationWrap"></div>
</div>
<app-cta-container [primaryBtnLabel]="screenLabels.CtaText | translate:{PartnerName: partnerName}"
    [secondaryBtnLabel]="screenLabels.CtaTextSecondary | translate" [isPrimaryBtnBlue]="true"
    [isSecondaryBtnHidden]="!isIncorrectPartner ? true : false" (actionSelected)="nextAction($event)"
    adobeSubmitTriggerClass='ab-unknown-partner-block'>
</app-cta-container>
